import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators  } from '@angular/forms';
// import { providerDef } from '@angular/core/src/view/provider';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as $ from "jquery";
import { of } from 'ramda';
import {Md5} from "ts-md5/dist/md5";
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';

@UntilDestroy()
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginForm : FormGroup;
  errorId : String;
  errorMessage : String | null | undefined;
  constructor(
    private route: ActivatedRoute,
    private fb : FormBuilder,
    private authService: AuthService,
    private userService: UserService,
    private readonly router: Router) {
      
    this.loginForm = fb.group({
      username:['', [Validators.required]],
      password:['', [Validators.required]]
    })
  }

  ngOnInit() {
    this.route.queryParams.subscribe(queryParams => {
      this.errorId = queryParams.error;
    });

    if(this.errorId) {
      this.setErrorMessage(this.errorId);
    }
  }

  loginValidate() {
    if (this.loginForm.valid) {
      this.errorMessage = null;
      // this.loginForm.patchValue({password: this.md5(this.loginForm.value["password"])});
      // $("form").submit();

      this.authService
      .login({username:this.loginForm.value['username'],password:this.md5(this.loginForm.value["password"])})
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        const targetUrl = 'mychatroom';//this.router.parseUrl(redirectUrl ?? this.authService.defaultPath);
        this.updateUserLoginInfo();
        this.router.navigateByUrl(targetUrl);
      });

    } else {
      this.errorMessage = "用户名或者密码错误.";
    }
  }

  updateUserLoginInfo(){
    this.authService.userId$.pipe().subscribe(
      (userId) =>{
        this.userService.updateLoginInfo({id: userId}).subscribe();
      }
    );
  }

  register(){
    this.router.navigateByUrl('register');
  }

  md5(pwd: string): string{
    // console.log('md5:'+Md5.hashStr(pwd).toString());
    return Md5.hashStr(pwd).toString();
  }

  setErrorMessage(errorId : String) {
    switch (errorId) {
      case '1': this.errorMessage = "用户名或者密码错误.";
    }
  }
} 

